import Avatar from '@mui/material/Avatar'
import { SxProps, Theme } from '@mui/material/styles'
import React from 'react'

import ToolTip from 'components/common/Tooltip'
import Endpoint from 'middleware/sagas/endpoint'

const { profilePicUri } = Endpoint.user

interface AvatarSquareProps {
  firstName?: string
  lastName?: string
  fromCDN?: boolean
  src?: string
  sx?: SxProps<Theme>
}

const AvatarSquare = ({ firstName = '', lastName = '', fromCDN = true, src, sx }: AvatarSquareProps) => {
  const initials = `${firstName?.charAt(0) ?? ''}${lastName?.charAt(0) ?? ''}`.trim()

  // I think no one is using this, we may need to migrate this to a separate API call
  const imgSrc = src && fromCDN ? profilePicUri + src : src

  return (
    <ToolTip title={`${firstName} ${lastName}`.trim()}>
      <Avatar
        src={imgSrc}
        sx={[
          { bgcolor: 'background.driverBg', color: 'background.paper', width: 24, height: 24, fontSize: 12 },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        variant="rounded"
      >
        {!src && initials}
      </Avatar>
    </ToolTip>
  )
}

export default AvatarSquare
